/* eslint-disable max-len */
export const REQUESTED_EXTRA_SESSIONS_AVAILABILITY_STATISTICS = 'REQUESTED_EXTRA_SESSIONS_AVAILABILITY_STATISTICS'
export const REQUESTED_EXTRA_SESSIONS_AVAILABILITY_STATISTICS_FAILED = 'REQUESTED_EXTRA_SESSIONS_AVAILABILITY_STATISTICS_FAILED'
export const REQUESTED_EXTRA_SESSIONS_AVAILABILITY_STATISTICS_SUCCESS = 'REQUESTED_EXTRA_SESSIONS_AVAILABILITY_STATISTICS_SUCCESS'

export const CLEAR_REQUESTED_EXTRA_SESSIONS_AVAILABILITY_STATISTICS = 'CLEAR_REQUESTED_EXTRA_SESSIONS_AVAILABILITY_STATISTICS'
